import { Field } from 'react-form';
import AsyncSelect from 'react-select/lib/Async';
import { AbconetApi } from '../AbconetApi';
 
export class ProductSelector extends React.Component {
    getProducts(input) {
        if (!input) {
            return Promise.resolve([]);
        }

        return AbconetApi.get(`/api/product/?term=${input}&itemsPerPage=10`).then((json) => {
            return json;
        });
    }

    render() {
        return (// Use the form field and your custom input together to create your very own input!
            <Field field={this.props.field}>
                {fieldApi => {

                    // Remember to pull off everything you dont want ending up on the <input>
                    // thats why we pull off onChange, onBlur, and field
                    // Note, the ...rest is important because it allows you to pass any
                    // additional fields to the internal <input>.
                    const { onChange, onBlur, field, ...rest } = this.props;

                    const { value, error, warning, success, setValue, setTouched } = fieldApi;

                    return (
                        <div>
                            <AsyncSelect
                                {...rest}
                                name="form-field-name"
                                value={value}
                                loadOptions={this.getProducts}
                                getOptionLabel={(option) => <div className="product-dropdown"><span className="stockcode">{option.stockcode}</span>{option.name}</div>}
                                getOptionValue={(option) => option.stockcode}
                                onChange={value => {
                                    setValue(value);

                                    if (onChange) {
                                        onChange(value);
                                    }
                                }}
                                onBlur={ev => {
                                    setTouched();
                                    if (onBlur) {
                                        onBlur(ev);
                                    }
                                }} />
                        </div>
                    );
                }}
            </Field>);
    }
}